export default "__VITE_ASSET__DLnonqOh__"